import { TeacherStatus } from 'constants/teacherRecruitment';
import { useEffect, useState } from 'react';
import warningIcon from '/static/svg/ic_alert_yellow.svg';
import closeIcon from '/static/svg/ic_close_banner.svg';
import { t } from 'utils/i18n';
import {
  BannerContainerStyles,
  ImgWarningStyles,
  TextBannerStyles,
  WrapperLeftWarningStyles,
} from 'layouts/dashboard/header/Header.styles';
import { useProfileService } from 'services/ProfileService';
import { useNavigate } from 'react-router-dom';
import { PATH } from 'routes/routeConfig';

const Banner = () => {
  const { infoTeacherRecruitment, profile } = useProfileService();
  const navigate = useNavigate();

  const [
    isHiddenWarningTerminatedContract,
    setIsHiddenWarningTerminatedContract,
  ] = useState<boolean>(false);
  const [isHiddenBannerReferenceSystem, setIsBannerReferenceSystem] =
    useState<boolean>(false);

  const [isMount, setIsMount] = useState<boolean>(false);

  useEffect(() => {
    if (infoTeacherRecruitment?.sentTerminatedContractTime) {
      if (infoTeacherRecruitment?.signedTerminatedContractTime) {
        setIsHiddenWarningTerminatedContract(false);
      } else {
        setIsHiddenWarningTerminatedContract(true);
      }
    }
    if (profile?.status && profile?.status === TeacherStatus.UNAVAILABLE) {
      setIsBannerReferenceSystem(false);
    } else {
      if (profile?.status && profile?.status !== TeacherStatus.UNVERIFIED) {
        setIsBannerReferenceSystem(true);
      }
    }
  }, [infoTeacherRecruitment, isMount]);
  const handleGoToTerminatedContract = () => {
    navigate(PATH.TEACHER_TERMINATED_CONTRACT, { replace: true });
  };

  useEffect(() => {
    const body = document.body;
    const mainLayout = body.querySelector(
      '.showHiddenWarningBanner',
    ) as HTMLElement;
    if (!mainLayout) return;
    if (
      (isHiddenWarningTerminatedContract && !isHiddenBannerReferenceSystem) ||
      (!isHiddenWarningTerminatedContract && isHiddenBannerReferenceSystem) ||
      (isHiddenWarningTerminatedContract && isHiddenBannerReferenceSystem)
    ) {
      mainLayout.style.paddingTop = '160px';
    } else {
      mainLayout.style.paddingTop = '116px';
    }
  }, [isHiddenWarningTerminatedContract, isHiddenBannerReferenceSystem]);

  const handleCloseWaringTerminatedContract = () => {
    setIsHiddenWarningTerminatedContract(false);
  };

  useEffect(() => {
    setIsMount(true);
  }, []);

  if (!isHiddenWarningTerminatedContract) return null;

  return (
    <BannerContainerStyles>
      <WrapperLeftWarningStyles onClick={handleGoToTerminatedContract}>
        <ImgWarningStyles src={warningIcon} />
        <TextBannerStyles>
          {t(
            'layouts.dashboard.header.banner.warningTerminatedContract',
            '您收到授課講師終止合約協議書，請盡快簽署',
          )}
        </TextBannerStyles>
      </WrapperLeftWarningStyles>

      <ImgWarningStyles
        src={closeIcon}
        onClick={handleCloseWaringTerminatedContract}
      />
    </BannerContainerStyles>
  );
};

export default Banner;
